module.exports = __webpack_public_path__ + "img/img-item.1376c64c.png";